<script>
export default {
  inject: ['reversoAllCounts', 'reversoFilterId'],

  props: {
    filter: {
      type: Object,
      required: true,
    },
    activeFilters: {
      type: Object,
      default: () => ({}),
    },
    numberProductsByFilters: {
      type: Object,
      default: () => {},
    },
  },

  emits: ['onItemSelected', 'onRemoveFilter'],

  computed: {
    value: {
      get() {
        const value = this.activeFilters[this.filter.id];
        if (Array.isArray(value)) {
          return value[0];
        }
        return value;
      },
      set(value) {
        this.$emit('onItemSelected', this.filter.id, value);
      },
    },

    filterItemsWithMonofaceInFirst() {
      return this.filter.items.toSorted((itemA, itemB) => itemA.label.localeCompare(itemB.label)).reverse();
    },
  },

  methods: {
    getInputId(item) {
      return `filtersub-desktop-${this.filter.id}-${item.value}`;
    },

    removeFilter() {
      this.$emit('onRemoveFilter', this.filter.id);
    },

    getNumberOfItemWithFilter(filter) {
      if (Object.hasOwn(filter, 'count')) {
        return filter.count;
      }

      const filterWithNbrProducts = this.numberProductsByFilters[this.reversoFilterId].find(
        (filterItem) => filterItem.value === filter.value,
      );
      return filterWithNbrProducts.nbrProducts;
    },
  },
};
</script>

<template>
  <ul
    class="radios-list radios-inline__list radios-as-button__list"
    data-cy="mixed-grid-filter-reverso"
    :data-cy-filter-id="filter.id"
  >
    <li>
      <div class="radio radio--as-button" @click="removeFilter">
        <input
          :name="`filtersub-desktop-${filter.id}`"
          class="radio__input"
          type="radio"
          :checked="!value"
          aria-describedby="form-group-radios-label form-group-radios-error form-group-radios-help"
        />

        <div class="radio__background"></div>

        <label class="radio__label radio__content">{{ $t('Products.filters.All') }}</label>

        <div class="radio--rich__wrapper radio__content">
          <div class="radio--rich__text">{{ reversoAllCounts }}</div>
        </div>
      </div>
    </li>

    <li v-for="item in filterItemsWithMonofaceInFirst" :key="item.value">
      <div class="radio radio--as-button">
        <input
          :id="getInputId(item)"
          v-model="value"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :name="`filtersub-desktop-${filter.id}`"
          :value="item.value"
          class="radio__input"
          type="radio"
          aria-describedby="form-group-radios-label form-group-radios-error form-group-radios-help"
        />

        <div class="radio__background"></div>

        <label :for="getInputId(item)" :data-cy-filter-value="item.label" class="radio__label radio__content">
          {{ item.label }}
        </label>

        <div class="radio--rich__wrapper radio__content">
          <div class="radio--rich__text">{{ getNumberOfItemWithFilter(item) }}</div>
        </div>
      </div>
    </li>
  </ul>
</template>
